// @ts-nocheck
import { TProcedurePayload } from 'clickNgo/models/api'

export const transformToProcedurePayload = <T extends object>(
  parameters: T
): TProcedurePayload<T> => {
  const keys = Object.keys(parameters)

  return keys.reduce((acc, key) => {
    const firstLetter = key[0].toUpperCase()
    const newKey = key.replace(key[0], firstLetter)

    acc[`p.${newKey}`] = Array.isArray(parameters[key])
      ? parameters[key].join(',')
      : parameters[key]
    return acc
  }, {} as TProcedurePayload<T>)
}
